import { HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  DocumentInterface,
  DocumentTypeEnum,
} from "src/app/core/interfaces/document-interface";
import { BackendService } from "src/app/core/services/backend-service";

@Injectable({
  providedIn: "root",
})
export class DocumentService extends BackendService {
  getDocuments(): Promise<DocumentInterface[]> {
    return this.get<DocumentInterface[]>("api/documents");
  }

  downloadDocument(documentId: number): Promise<HttpResponse<Blob>> {
    let params = new HttpParams();
    params = params.append("documentId", documentId);
    return this.downloadBlob("api/documents/download", params);
  }

  deleteDocument(documentId: number): Promise<void> {
    let params = new HttpParams();
    params = params.append("documentId", documentId);
    return this.delete<void>("api/documents", params);
  }

  addDocument(
    docType: DocumentTypeEnum,
    file: File
  ): Promise<DocumentInterface> {
    const formData = new FormData();
    formData.append("file", file);

    let params = new HttpParams();
    params = params.append("documentType", docType);

    return this.post<FormData, DocumentInterface>(
      "api/documents",
      formData,
      params
    );
  }
}
